import { createClient } from '@supabase/supabase-js';

// Publiczne dane projektu Supabase.
// Klucz "publishable" (anon) jest z założenia jawny — i tak trafia do bundla w przeglądarce.
// Dostępu do danych pilnuje RLS w bazie (publiczny odczyt, zapis tylko dla zalogowanych),
// a sekretny service_role key nigdy nie trafia do repozytorium.
// Dzięki wartościom domyślnym aplikacja działa nawet bez konfiguracji zmiennych na hostingu;
// zmienne środowiskowe (np. w Netlify) nadal mają pierwszeństwo.
const DEFAULT_URL = 'https://cyvedwbsxfcogevhgzya.supabase.co';
const DEFAULT_ANON_KEY = 'sb_publishable__p9O2eiEtej58IMr7uO9tQ_qbWCEbY5';

const url = process.env.REACT_APP_SUPABASE_URL || DEFAULT_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || DEFAULT_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = createClient(url, anonKey);
